<template>
  <div class="report-sales-budget">
    <simulation-modal ref="simulationModal" @register="assignData" />
    <div class="filter">
      <el-form inline style="padding-left: 20px;" v-loading="isSending">
        <el-date-picker
         v-model="searchForm.date"
         size="mini"
         :clearable="false"
         type="month">
        </el-date-picker>
        <el-button size="mini" type="primary" @click="fetchData" :disabled="isLoading">表示</el-button>
        <div style="float: right; padding-right: 20px;">
          <el-button size="mini" type="success" @click="showModal">一括登録</el-button>
          <el-button size="mini" type="success" @click="submit">登録</el-button>
        </div>
      </el-form>
    </div>
    <div>
      <el-table
        :data="items"
        border
        stripe
        show-summary
        :summary-method="getSummaries"
        style="width: 100%;">
        <el-table-column
          prop="date"
          width="150"
          fixed
          align="center"
          label="年月日">
          <template slot-scope="scope">
            <div class="date">
              {{ scope.row.date|date }}
              <span class="w" :class="weekdayClass(scope.row)">{{ printWeekday(scope.row) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="前年">
          <el-table-column
            class-name="sales-prev"
            label="売上"
            align="center">
            <template slot-scope="scope">
              <div class="sales-prev">
                {{ scope.row.prevSales|addFigure }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            class-name="person-prev"
            label="客数"
            align="center">
            <template slot-scope="scope">
              <div class="person-prev">
                {{ scope.row.prevPerson|addFigure }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            class-name="person-sales-prev"
            label="客単価"
            align="center">
            <template slot-scope="scope">
              <div class="person-sales-prev">
                {{ roundFilter(scope.row.prevSalesPerson)|addFigure }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" label="予算">
          <el-table-column
            class-name="current-sales-fixed"
            label="売上（確定）"
            align="center">
            <template slot-scope="scope">
              <div class="current-sales-fixed">{{ fixedBudget(form[scope.row.date])|addFigure }}</div>
            </template>
          </el-table-column>
          <el-table-column
            class-name="current-sales-budget"
            label="売上"
            align="center">
            <template slot-scope="scope">
              <div class="current-sales-budget">
                <input type="text"
                  v-model="form[scope.row.date].budget"
                  v-on:keydown.enter.prevent="nextFocus"
                  v-on:keydown.tab.prevent="nextFocus"
                  @change="handleChangeBudget(form[scope.row.date])"
                  @focus="handleFocusIn($event, scope.row.date, 'budget')"
                  @focusout="handleFocusOut(scope.row.date, 'budget')"
                  placeholder="売上予算" :tabindex="(scope.$index * 3) + 1" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            class-name="current-person"
            label="客数"
            align="center">
            <template slot-scope="scope">
              <div class="current-person">
                <input type="text"
                  v-model="form[scope.row.date].person"
                  v-on:keydown.enter.prevent="nextFocus"
                  v-on:keydown.tab.prevent="nextFocus"
                  @change="handleChangePerson(form[scope.row.date])"
                  @focus="handleFocusIn($event, scope.row.date, 'person')"
                  @focusout="handleFocusOut(scope.row.date, 'person')"
                  placeholder="客数"
                  :tabindex="(scope.$index * 3) + 2" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            class-name="current-person-sales"
            label="客単価"
            align="center">
            <template slot-scope="scope">
              <div class="current-person-sales">
                <input type="text"
                  v-model="form[scope.row.date].personSales"
                  v-on:keydown.enter.prevent="nextFocus"
                  v-on:keydown.tab.prevent="nextFocus"
                  @change="handleChangePersonSales(form[scope.row.date])"
                  @focus="handleFocusIn($event, scope.row.date, 'personSales')"
                  @focusout="handleFocusOut(scope.row.date, 'personSales')"
                  placeholder="客単価"
                  :tabindex="(scope.$index * 3) + 3" />
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import SimulationModal from './SimulationModal'
import $ from 'jquery'
import addFigure from '@/misc/addFigure'
import removeFigure from '@/misc/removeFigure'
import {mapGetters} from 'vuex'

export default {
  name: 'ReportSalesBudget',
  components: {
    SimulationModal,
  },
  filters: {
    date (value) {
      return moment(value).format('YYYY/MM/DD')
    },
    roundFilter (value) {
      if (!value) {
        return value
      }
      return this.rounding(value)
    },
  },
  data () {
    return {
      rounding: null,
      isLoading: false,
      isSending: false,
      searchForm: {
        date: null,
        year: null,
        month: null,
      },
      items: [],
      totalPrevSales: 0,
      totalPrevPerson: 0,
      totalPrevSalesPerson: 0,
      form: {},
    }
  },
  computed: {
    ...mapGetters('report', ['roundingFunction']),
  },
  created () {
    this.rounding = this.roundingFunction
  },
  mounted () {
    this.searchForm.date = moment()
    this.fetchData()
  },
  methods: {
    fetchData () {
      let tmp = moment(this.searchForm.date)
      let year = tmp.year()
      let month = tmp.month() + 1
      this.isLoading = true
      this.$request.salesBudgets.list(year, month).then(res => {
        this.items = res.body.results

        this.totalPrevSales = 0
        this.totalPrevPerson = 0
        this.totalPrevSalesPerson = 0

        Object.keys(this.form).forEach(k => {
          this.$delete(this.form, k)
        })
        this.items.map(x => {
          this.totalPrevSales += x.prevSales
          this.totalPrevPerson += x.prevPerson
          this.totalPrevSalesPerson += x.prevSalesPerson
          this.$set(this.form, x.date, {
            'person': addFigure(x.person || ''),
            'personSales': addFigure(this.rounding(x.personSales) || ''),
            'budget': addFigure(x.budget || ''),
          })
        })
      }, err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    },
    handleFocusIn (e, date, key) {
      this.form[date][key] = removeFigure(this.form[date][key])
      this.$nextTick(() => {
        e.target.select()
      })
    },
    handleFocusOut (date, key) {
      this.form[date][key] = addFigure(this.form[date][key])
    },
    handleChangeBudget (form) {
      let personSales = removeFigure(form.personSales)
      let budget = removeFigure(form.budget)
      let person = removeFigure(form.person)

      if (!budget) {
        return
      }

      if (personSales) {
        form.person = addFigure(this.rounding(budget / personSales))
      } else if (person) {
        form.personSales = addFigure(this.rounding(budget / person))
      }
    },
    handleChangePerson (form) {
      let personSales = removeFigure(form.personSales)
      let budget = removeFigure(form.budget)
      let person = removeFigure(form.person)

      if (!person) {
        return
      }

      if (personSales) {
        form.budget = addFigure(person * personSales)
      } else if (budget) {
        form.personSales = addFigure(this.rounding(budget / person))
      }
    },
    handleChangePersonSales (form) {
      let personSales = removeFigure(form.personSales)
      let budget = removeFigure(form.budget)
      let person = removeFigure(form.person)

      if (!personSales) {
        return
      }

      if (person) {
        form.budget = addFigure(person * personSales)
      } else if (budget) {
        form.person = addFigure(this.rounding(budget / personSales))
      }
    },
    fixedBudget (form) {
      let personSales = removeFigure(form.personSales)
      let person = removeFigure(form.person)
      if (personSales && person) {
        return person * personSales
      }
      return '-'
    },
    nextFocus (event) {
      let tabIndex = event.target.tabIndex + 3

      let element = $(this.$el).find('input[tabindex=' + tabIndex + ']')
      if (element.length === 0) {
        element = $(this.$el).find('input[tabindex=' + (event.target.tabIndex % 3 + 1) + ']')
      }
      if (element.length) {
        element[0].focus()
      }
    },
    getSummaries ({columns, data}) {
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合計'
          return true
        }
        switch (index) {
          case 1:
            // 前年売上
            sums[index] = this.totalPrevSales
            break
          case 2:
            // 前年客数
            sums[index] = this.totalPrevPerson
            break
          case 3:
            // 前年客単価
            sums[index] = this.rounding(this.totalPrevSalesPerson)
            break
          case 4:
            {
              let sum = 0
              Object.keys(this.form).map(k => {
                let person = removeFigure(this.form[k].person)
                let personSales = removeFigure(this.form[k].personSales)
                if (person && personSales) {
                  sum += person * personSales
                }
              })
              sums[index] = sum
            }
            break
          case 5:
            {
              let sum = 0
              Object.keys(this.form).map(k => {
                let num = removeFigure(this.form[k].budget)
                if (!num || isNaN(num)) {
                  return true
                }
                sum += num
              })
              sums[index] = sum
            }
            break
          case 6:
            {
              let sum = 0
              Object.keys(this.form).map(k => {
                let num = removeFigure(this.form[k].person)
                if (!num || isNaN(num)) {
                  return true
                }
                sum += num
              })
              sums[index] = sum
            }
            break
          case 7:
            {
              let sum = 0
              let count = 0
              Object.keys(this.form).map(k => {
                let num = removeFigure(this.form[k].personSales)
                if (!num || isNaN(num)) {
                  return true
                }
                count++
                sum += num
              })
              if (count !== 0) {
                sum /= count
              }
              sums[index] = this.rounding(sum)
            }
            break
          default:
            sums[index] = '実装中'
        }
      })
      return sums.map(x => addFigure(x))
    },
    printWeekday (item) {
      if (item.isHoliday) {
        return '祝'
      }
      return moment(item.date).locale('ja').format('ddd')
    },
    weekdayClass (item) {
      if (item.isHoliday) {
        return 'hol'
      }
      let ret = moment(item.date).locale('en').format('ddd').toLowerCase()
      if (item.isBeforeHoliday && ret !== 'sun') {
        return 'bho'
      }
      return ret
    },
    submit () {
      let data = []
      Object.keys(this.form).forEach(k => {
        const tmp = {
          date: k,
          person: removeFigure(this.form[k].person) || 0,
          budget: removeFigure(this.form[k].budget) || 0,
        }
        data.push(tmp)
      })
      console.log(data)
      this.isSending = true
      this.$request.salesBudgets.bulkInsert(data).then(res => {
        this.$message('登録しました')
      }).finally(() => {
        this.isSending = false
      })
    },
    showModal () {
      this.$refs.simulationModal.show(this.items)
    },
    assignData (data) {
      const labels = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']
      this.items.forEach(item => {
        const weekday = moment(item.date).weekday()
        const label = item.isHoliday ? 'hol' : (item.isBeforeHoliday ? 'bho' : labels[weekday])
        if (!data[label]) {
          return true
        }
        const form = this.form[item.date]
        const tmp = data[label]
        form.budget = addFigure(tmp.sales)
        form.person = addFigure(tmp.person)
        form.personSales = addFigure(tmp.personSales)
      })
    },
    roundFilter (value) {
      if (!value) {
        return value
      }
      return this.rounding(value)
    },
  },
}
</script>

<style scoped>
.filter {
  width: 100%;
  height: 50px;
  background-color: #FFF;
  border-bottom: 1px solid #EEE;
  overflow: hidden;
  z-index: 10;
}

.filter .el-form--inline {
  height: 50px;
  line-height: 50px;
}

div.date {
  text-align: center;
  height: 40px;
  line-height: 40px;
}

div.date span.w {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  background-color: #ABC;
  border-radius: 50%;
  line-height: 16px;
  font-size: 0.7em;
  text-align: center;
  color: #FFF;
  vertical-align: 2px;
}

div.date span.w.sat,
div.date span.w.bho {
  background-color: #3CD;
}

div.date span.w.sun,
div.date span.w.hol {
  background-color: #E34;
}

.sales-prev {
}

</style>

<style>
div.report-sales-budget .el-table td,
div.report-sales-budget .el-table th {
  padding: 0px;
}

.sales-prev,
.person-prev,
.person-sales-prev {
  text-align: right;
}

.current-sales-fixed {
  text-align: right;
  font-weight: bold;
}

.current-sales-budget,
.current-person,
.current-person-sales {
  text-align: right;
}

.current-sales-budget input[type=text],
.current-person input[type=text],
.current-person-sales input[type=text] {
  width: 100%;
  height: 30px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/SalesBudget.vue